import { render, staticRenderFns } from "./Orderform2.vue?vue&type=template&id=bf7cdbf2"
import script from "./Orderform2.vue?vue&type=script&lang=js"
export * from "./Orderform2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports